/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

const ModalImg = ({ img = '', useModal = 'si' }) => {
  const [modalShow, setModalShow] = useState(false);
  return (
    <React.Fragment>
      {useModal === 'si' && (
        <Button
          type="button"
          label=""
          icon="pi pi-question"
          className="btn-info-label"
          tooltipOptions={{ position: 'top' }}
          tooltip={'Click para ver ejemplo'}
          onClick={() => {
            setModalShow(true);
          }}
        />
      )}
      {useModal === 'no' && (
        <Button
          type="button"
          label=""
          icon="pi pi-question"
          className="btn-info-label"
          tooltipOptions={{ position: 'top' }}
        />
      )}
      {useModal === 'no' && (
        <Tooltip target=".btn-info-label" position="top" className="tool-imagen">
          <img
            alt="logo"
            src={img}
            data-pr-tooltip="PrimeReact-Logo"
            width="750px"
            height="auto"
          />
        </Tooltip>
      )}
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <img src={img} style={{ width: '100%' }} alt="IMG" />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ModalImg;
